module.exports = __webpack_public_path__ + "img/grip-vertical.f1a8c028.svg";